import { brazilNorthTrust } from "./eprs.js";
import { zaneNorth } from "./patients.js";
export const Zane_Bridges_on_Rio_North_Trust = {
    id: "7bef17b8-093f-4ea3-a8ff-c4011a4442ba",
    patientId: "970e623c-9089-46d5-b2f0-184d31a06b0c",
    externalSystemType: "rio",
    externalSystemId: brazilNorthTrust.id,
    externalPatientIdType: "nhs.number",
    externalPatientIdValue: ["9736333914"],
    priorityWithinExternalSystem: 1,
    isInvalid: false,
};
export const Zane_Bridgerton_on_Rio_North_Trust = {
    id: "616d9a93-7fbc-4752-8ba1-0e1b20212ce6",
    patientId: "f27d0f3b-33fe-4cc1-a719-a479db1057c8",
    externalSystemType: "rio",
    externalSystemId: brazilNorthTrust.id,
    externalPatientIdType: "nhs.number",
    externalPatientIdValue: ["9736333922"],
    priorityWithinExternalSystem: 1,
    isInvalid: false,
};
export const Zane_North_on_Rio_North_Trust = {
    id: "1c4d01cc-5d27-4a70-b92c-03fca63a6614",
    patientId: zaneNorth.id,
    externalSystemType: "rio",
    externalSystemId: brazilNorthTrust.id,
    externalPatientIdType: "nhs.number",
    externalPatientIdValue: ["9736333930"],
    priorityWithinExternalSystem: 1,
    isInvalid: false,
};
export const defaultExternalPatientLinks = [
    Zane_Bridges_on_Rio_North_Trust,
    Zane_Bridgerton_on_Rio_North_Trust,
    Zane_North_on_Rio_North_Trust,
];
//# sourceMappingURL=externalPatientLinks.js.map